import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import AuthenticationFactorModalActionModify
  from './AuthenticationFactorModalActionModify';
import AuthenticationFactorModalActionDefault
  from './AuthenticationFactorModalActionDefault';

const AuthenticationFactorModalActionPicker = ({ authenticationFactorResource }) => {
  return pickFunction(authenticationFactorResource, {
    [fr.relationships.authenticationFactorModify.name]: () => {
      return (
        <AuthenticationFactorModalActionModify authenticationFactorResource={authenticationFactorResource} />
      );
    },
    [fr.relationships.default.name]: () => {
      return (
        <AuthenticationFactorModalActionDefault authenticationFactorResource={authenticationFactorResource} />
      );
    },
  });
};

export default AuthenticationFactorModalActionPicker;
